export default "__VITE_ASSET__DPMMpbH$__"